import { HttpErrorResponse } from '@angular/common/http';
import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { notificationsPerPageInitial } from '../constants';
import { Notification } from '../entities';

import * as NotificationsActions from './notifications.actions';
import { NotificationsPageParams } from './notifications.model';

export const featureKey = 'notifications';

export interface NotificationsState {
    loading: boolean;
    loaded: boolean;
    pageParams: NotificationsPageParams;
    totalElements: number;
    loadError: HttpErrorResponse | null;
    notificationIdsInProgress: number[];
    unreadCount: number;
    unreadCountLoading: boolean;
}

export interface NotificationsEntityState extends EntityState<Notification>, NotificationsState {}

const initialNotificationsListPageParams: NotificationsPageParams = {
    page: 0,
    size: notificationsPerPageInitial
};

const initialState: NotificationsState = {
    loading: true,
    loaded: false,
    pageParams: initialNotificationsListPageParams,
    totalElements: 0,
    loadError: null,
    notificationIdsInProgress: [],
    unreadCount: 0,
    unreadCountLoading: false
};

export const notificationsAdapter = createEntityAdapter<Notification>();

const initialNotificationsState = notificationsAdapter.getInitialState(initialState);

export const reducer = createReducer(
    initialNotificationsState,
    on(NotificationsActions.loadNotificationsList, (state) => ({
        ...state,
        loading: true
    })),
    on(NotificationsActions.loadNotificationsListSuccess, (state, { response }) =>
        notificationsAdapter.setAll(response.content, {
            ...state,
            totalElements: response.totalElements,
            loading: false,
            loaded: true
        })
    ),
    on(NotificationsActions.loadNotificationsListFailure, (state, { error }) => ({
        ...state,
        loading: false,
        loadError: error
    })),

    on(NotificationsActions.makeNotificationRead, (state, { id }) => ({
        ...state,
        notificationIdsInProgress: [...state.notificationIdsInProgress, id]
    })),
    on(NotificationsActions.makeNotificationReadSuccess, (state, { id }) =>
        notificationsAdapter.updateOne(
            { id, changes: { read: true } },
            {
                ...state,
                notificationIdsInProgress: state.notificationIdsInProgress.filter((idProgress) => idProgress !== id)
            }
        )
    ),
    on(NotificationsActions.makeNotificationReadFailure, (state, { id }) => ({
        ...state,
        notificationIdsInProgress: state.notificationIdsInProgress.filter((idProgress) => idProgress !== id)
    })),

    on(NotificationsActions.setPageParams, (state, { pageParams }) => ({
        ...state,
        pageParams
    })),

    on(NotificationsActions.loadUnreadCount, (state) => ({
        ...state,
        unreadCountLoading: true
    })),
    on(NotificationsActions.loadUnreadCountSuccess, (state, { unreadCount }) => ({
        ...state,
        unreadCount,
        unreadCountLoading: false
    })),
    on(NotificationsActions.loadUnreadCountFailure, (state) => ({
        ...state,
        unreadCountLoading: false
    }))
);
